const _excluded = ["children", "title", "backTitle", "mobileTitle", "isDesktop", "onClose", "testId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { Button, CloseButton, ConfirmationModal, CustomModal, FullBox, TextButton, Typography } from 'seagull';
import { WideArrowBackward } from 'seagull/icons';
import styles from "./ResponsiveModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function isConfirmationModalProps(props) {
  return 'onPrimaryButtonClick' in props;
}
export function ResponsiveModal(props) {
  var _props$skin, _props$skin2;
  const {
      children,
      title,
      backTitle,
      mobileTitle = title,
      isDesktop,
      onClose,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  if (isDesktop) {
    if (isConfirmationModalProps(props)) {
      const {
        skin,
        primaryButtonDisabled,
        primaryButtonLabel,
        primaryButtonIntent,
        onPrimaryButtonClick,
        secondaryButtonLabel,
        onSecondaryButtonClick
      } = props;
      return /*#__PURE__*/_jsx(ConfirmationModal, _objectSpread({
        testId: testId,
        textAlignCenter: false,
        content: children,
        title: title !== null && title !== void 0 ? title : '',
        skin: skin,
        onCloseButtonClick: onClose,
        primaryButtonIntent: primaryButtonIntent,
        primaryButtonDisabled: primaryButtonDisabled,
        primaryButtonLabel: primaryButtonLabel,
        onPrimaryButtonClick: onPrimaryButtonClick,
        secondaryButtonLabel: secondaryButtonLabel,
        onSecondaryButtonClick: onSecondaryButtonClick
      }, rest));
    } else {
      return /*#__PURE__*/_jsx(CustomModal, _objectSpread(_objectSpread({
        hideCloseBtn: true,
        maxWidth: 600,
        testId: testId
      }, rest), {}, {
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.customModal,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.customModalHeader,
            children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(Typography, {
              variant: "h6",
              weight: "bold",
              children: title
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(CloseButton, {
                skin: "transparent",
                onClick: onClose
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: styles.customModalBody,
            children: children
          })]
        })
      }));
    }
  }
  return /*#__PURE__*/_jsxs(FullBox, _objectSpread(_objectSpread({
    flexDirection: "column",
    className: styles.mobileModal,
    testId: testId
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.mobileModalHeader,
      children: /*#__PURE__*/_jsx(TextButton, {
        skin: "secondary",
        prefixIcon: /*#__PURE__*/_jsx(WideArrowBackward, {}),
        underline: "hover",
        onClick: onClose,
        children: backTitle
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.mobileModalBody,
      children: [mobileTitle && /*#__PURE__*/_jsx(Typography, {
        weight: "bold",
        variant: "h6",
        className: styles.mobileModalTitle,
        children: mobileTitle
      }), children]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.mobileModalFooter,
      children: isConfirmationModalProps(props) ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          fluid: true,
          size: "medium",
          skin: "".concat((_props$skin = props.skin) !== null && _props$skin !== void 0 ? _props$skin : 'primary'),
          onClick: props.onPrimaryButtonClick,
          testId: "confirmation-modal-primary-btn",
          disabled: props.primaryButtonDisabled,
          children: props.primaryButtonLabel
        }), props.secondaryButtonLabel && /*#__PURE__*/_jsx(Button, {
          fluid: true,
          size: "medium",
          skin: "".concat((_props$skin2 = props.skin) !== null && _props$skin2 !== void 0 ? _props$skin2 : 'primary', "Outline"),
          onClick: props.onSecondaryButtonClick,
          testId: "confirmation-modal-secondary-btn",
          children: props.secondaryButtonLabel
        })]
      }) : /*#__PURE__*/_jsx(Button, {
        fluid: true,
        onClick: onClose,
        children: "Back"
      })
    })]
  }));
}